import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   loading: false,
   reporting: { text: "", type: "info", isReporting: false },
   isLoggedIn: false,
};

const utilities = createSlice({
   name: "utilities",
   initialState,
   reducers: {
      setLoading(state, action) {
         state.loading = action.payload;
      },

      setReporting(state, action) {
         state.reporting = action.payload;
      },

      setLoginStatus(state, action) {
         state.reporting = action.payload;
      },
   },
});

export const utilitiesAction = utilities.actions;
export const utilitiesReducer = utilities.reducer;
